import { FC } from 'react';
import { CardContainer } from './Card.styles';
import { ContainerProps } from '@mui/material';

type CardProps = ContainerProps;

export const Card: FC<CardProps> = ({ ...props }) => {
  return <CardContainer {...props} />;
};

export default Card;
